import { interval } from 'rxjs';
import { startWith } from 'rxjs/operators';

import request from '@utils/axiosWrapper';
import * as Ids from '@utils/ids';

const POLLING_INTERVAL = 60 * 60 * 1000;

/** 风控数据定时上报 */
const init = () => {
    interval(POLLING_INTERVAL)
        .pipe(startWith(0))
        .subscribe(() => {
            // eslint-disable-next-line waimaie/no-direct-access-localstorage
            const logonSuccess = localStorage.getItem('logonSuccess');
            const type = logonSuccess === 'true' ? 1 : 2;
            const longitude = '';
            const latitude = '';
            const ip = '';
            const origin = window.location.origin;
            const url = '/v2/common/operation/w/status';
            let fingerprintInfo = '';

            const fingerUrl = `${origin}${url}?acctId=${Ids.getAcctId()}&wmPoiId=${Ids.getWmPoiId()}&deviceUuid=${Ids.getDeviceId()}&type=${type}&longitude=${longitude}&latitude=${latitude}&ip=${ip}`;

            if (window.Rohr_Opt && typeof window.Rohr_Opt.reload === 'function') {
                fingerprintInfo = window.Rohr_Opt.reload(fingerUrl);
            }

            // eslint-disable-next-line waimaie/no-direct-access-localstorage
            localStorage.removeItem('logonSuccess');

            request.postAsFormSubmit(url, {
                wmPoiId: Ids.getWmPoiId(),
                acctId: Ids.getAcctId(),
                uuid: Ids.getDeviceId(),
                type,
                longitude,
                latitude,
                ip,
                fingerprintInfo,
            });
        });
};

export default { init };
